export default "__VITE_ASSET__93YCbwnd__"